import { z } from 'zod'

const text = z.string().trim().min(1)
const courseId = z.string().regex(/^[a-z0-9][a-z0-9-]{0,127}$/u)

export const learningProgramDefinitionRequirementSchema = z.object({
  id: text.max(180),
  courseId,
  courseSlug: text.max(180),
  title: text.max(240),
  catalogNodeId: text.max(160),
  prerequisites: z.array(text.max(180)).max(100),
  required: z.boolean(),
  requiredOutcome: z.enum(['completed', 'passed']),
  acceptedEvidenceStandards: z.array(text.max(160)).max(50),
  evidenceStandard: z.enum(['self-attested', 'server-verified']).optional(),
  groupId: text.max(180).nullable().optional(),
  order: z.number().int().nonnegative().max(100000).optional(),
}).strict()

export const learningProgramDefinitionElectiveGroupSchema = z.object({
  id: text.max(180),
  title: text.max(240),
  choose: z.number().int().positive().max(100),
}).strict()

export const learningProgramDefinitionSchema = z.object({
  schemaVersion: z.literal('learning-program-v1'),
  programId: text.max(180),
  version: text.max(120),
  title: text.max(240),
  outcome: text.max(240),
  requirements: z.array(learningProgramDefinitionRequirementSchema),
  electiveGroups: z.array(learningProgramDefinitionElectiveGroupSchema),
  creditReuse: z.enum(['compatible', 'after-enrollment']),
  credentialPolicy: z.record(z.unknown()),
}).strict()

export const learningProgramAchievementSchema = z.object({
  id: text.max(240),
  enrollmentId: text.max(180),
  learnerId: text.max(180),
  programVersionId: text.max(180),
  completedAt: z.string().datetime({ offset: true }),
  evidenceIds: z.array(text.max(240)),
  decisionProvenanceHash: text.nullable(),
}).strict()

export type LearningProgramDefinitionRequirement = z.infer<typeof learningProgramDefinitionRequirementSchema>
export type LearningProgramDefinitionElectiveGroup = z.infer<typeof learningProgramDefinitionElectiveGroupSchema>
export type LearningProgramDefinition = z.infer<typeof learningProgramDefinitionSchema>
export type LearningProgramAchievement = z.infer<typeof learningProgramAchievementSchema>
